import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { message, Input, Button } from 'antd';
import { common } from "../../utils";
import NoneData from "../common/NoneData";
import moment from "moment";
export class CourseAnswer extends Component {
  static propTypes = {
    course: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    answerTxt: "",
    isShowAll: false,
  }
  onAnswer(e) {
    if (e.target.value.length > 300) return;
    this.setState({
      answerTxt: e.target.value,
    })
  }
  onAnswerSubmit() {
    const { CourseID, ChapterID } = this.props;
    if (this.state.answerTxt.trim() === "") {
      message.warning("提问内容不能为空");
      return;
    }
    //提问课程
    this.props.actions.fetchAddAnswer({
      Chapter_ID: ChapterID,
      Content: this.state.answerTxt,
      Course_ID: CourseID,
    }).then(res => {
      if (res.SuccessResponse) {
        this.setState({
          answerTxt: "",
        }, () => {
          //提问成功后更新数据
          message.success("提问成功");
          //获取答疑列表数据
          this.props.actions.fetchGetAnswerList({
            Course_ID: CourseID,
          });
        })

      }
    })

  }
  render() {
    const { CourseID, IsPay, } = this.props;
    const { answerTxt, isShowAll } = this.state;
    const { fetchGetAnswerListSuccess } = this.props.course;

    let listData = fetchGetAnswerListSuccess ? fetchGetAnswerListSuccess : [];
    let answerTotal = (fetchGetAnswerListSuccess && fetchGetAnswerListSuccess.length) || 0;
    if (!isShowAll) {
      listData = listData.slice(0, 4);
    }
    return (
      <div className="course-course-answer">
        <div className="inner">
          {
            IsPay === 0 ? <div className="noBuy-answerView">
              <p>你需要购买课程后才可提问<u onClick={() => {
                this.props.actions.fetchGetIsOrder({
                  BusType: 0, BusId: CourseID
                }).then(res => {
                  if (res.SuccessResponse) {
                    common.GetIsOrder(res.Data, this.props.history, '课程', () => {
                      //直接生成订单跳支付
                      this.props.actions.fetchDirectOrder({
                        BusType: 0,//0课程 1课程包 2课程阶段
                        BusId: CourseID
                      }).then(res => {
                        if (res.SuccessResponse) {
                          let params = {};
                          params.OrderId = res.Data.OrderId;
                          params.Money = res.Data.Price;
                          params.OrderName = "课程支付";
                          params.IsStudent = 1;
                          this.props.actions.fetchUnifiedCreateOrder(params).then(res => {
                            if (res.SuccessResponse) {
                              this.props.history.push(`/paytype/${res.Data.OrderId}`);
                            }
                          })
                        }
                      })
                    });
                  }
                })
              }}>立即购买</u></p>
            </div> : <div className="Buy-answerView">
                <div className="inputView">
                  <Input.TextArea onChange={this.onAnswer.bind(this)} placeholder="快来提出你的问题" value={answerTxt}></Input.TextArea>
                  <span>{this.state.answerTxt.length}/300</span>
                </div>
                <div className="inputBtn">
                  <Button type="theme" onClick={this.onAnswerSubmit.bind(this)}>提问</Button>
                </div>
              </div>
          }
          <div className="line"></div>
          {
            listData.length > 0 && <div className="answer-list">
              <h1>全部答疑<span>{answerTotal}</span></h1>
              <div className="items">
                {
                  listData.map(item => (
                    <div key={item.ID} className="item">
                      <div className="answer">
                        <p className="p1">
                          <span className="answer-span">问</span>
                          <span>{item.StudentName}</span>
                          <span>{moment(new Date(item.AddCommentTime)).format("YYYY-MM-DD HH:mm:ss")}</span>
                        </p>
                        <p className="p2">
                          {item.CommentContent}
                        </p>
                      </div>
                      {
                        item.NewInterlocution.ReplyContent && <div className="reply">
                          <p className="p1">
                            <span className="reply-span">答</span>
                            <span>{item.NewInterlocution.AccountName}</span>
                            <span>{moment(new Date(item.NewInterlocution.AddReplyTime)).format("YYYY-MM-DD HH:mm:ss")}</span>
                          </p>
                          <p className="p2">
                            {item.NewInterlocution.ReplyContent}
                          </p>
                        </div>
                      }
                    </div>
                  ))
                }
                {
                  isShowAll && <h3>没有更多的答疑了</h3>
                }
                {
                  !isShowAll && <h2 onClick={() => {
                    this.setState({
                      isShowAll: true,
                    })
                  }}>查看全部答疑</h2>
                }
              </div>
            </div>
          }
          {
            listData.length === 0 && <div className="noneData">
              <NoneData type={2} />
            </div>
          }
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    course: state.course,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseAnswer);



// WEBPACK FOOTER //
// ./src/features/course/CourseAnswer.js